var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var TOUR_HUNTER_PENDING_TOUR_ID_KEY = 'tour-hunter-toggle-pending-tour-id';
        var TOUR_HUNTER_BACK_INTERCEPT_STATE_TYPE = 'tour-hunter-back-intercept';
        var TOUR_HUNTER_TOGGLE_EVENT_NAME = 'click_tour_hunter_toggle';
        var TOUR_HUNTER_ADD_SUCCESS_EVENT_NAME = 'tour_hunter_add_success';
        var TOUR_HUNTER_TOGGLE_PLACE = 'tour-hunter-toggle-btn';
        var TOUR_HUNTER_BACK_INTERCEPT_PLACE = 'tour-hunter-back-intercept-add';
        var TOUR_HUNTER_STATUS_ADD = 'added';
        var TOUR_HUNTER_STATUS_REMOVE = 'removed';

        var TourHunterToggleWidget = function () {
            function TourHunterToggleWidget() {
                _classCallCheck(this, TourHunterToggleWidget);

                this.pendingTourSyncTimer = null;
                this.popupHideTimer = null;
                this.popupFadeTimer = null;
                this.popup = null;
                this.popupTexts = window.tourHunterTogglePopupTexts || {};
                this.currentHistoryState = window.history ? window.history.state : null;
                this.backInterceptConfig = this.getBackInterceptConfig();
                this.isBackInterceptModalOpen = false;
                this.isBackNavigationConfirmed = false;
                this.pendingBackNavigation = null;
                this.pendingTourInProgress = false;

                this.bindEvents();
                this.initBackIntercept();
                this.startPendingTourSync();
            }

            _createClass(TourHunterToggleWidget, [{
                key: "bindEvents",
                value: function bindEvents() {
                    var _this = this;

                    document.addEventListener('click', function (event) {
                        var targetElement = event.target.closest('.tour-hunter-toggle-btn');

                        if (targetElement) {
                            _this.handleClick(targetElement, TOUR_HUNTER_TOGGLE_PLACE);
                        }

                        var addFromBackInterceptButton = event.target.closest('.js-tour-hunter-back-intercept-add');

                        if (addFromBackInterceptButton) {
                            _this.handleBackInterceptAdd();
                        }

                        var closeBackInterceptButton = event.target.closest('.js-tour-hunter-back-intercept-close');

                        if (closeBackInterceptButton) {
                            _this.handleBackInterceptClose();
                        }
                    }, true);
                }
            }, {
                key: "initBackIntercept",
                value: function initBackIntercept() {
                    var _this2 = this;

                    if (!this.backInterceptConfig || !window.history || !window.modal) {
                        return;
                    }

                    this.patchHistoryStateTracking();
                    this.pushBackInterceptState();

                    window.addEventListener('nav-bar:before-back', function (event) {
                        _this2.handleNavBarBack(event);
                    });

                    window.addEventListener('popstate', function (event) {
                        _this2.handlePopState(event);
                    });
                }
            }, {
                key: "patchHistoryStateTracking",
                value: function patchHistoryStateTracking() {
                    var _this3 = this;

                    if (!window.history || window.history.__tourHunterToggleStateTrackingPatched) {
                        return;
                    }

                    var pushState = window.history.pushState;
                    var replaceState = window.history.replaceState;

                    window.history.pushState = function () {
                        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                            args[_key] = arguments[_key];
                        }

                        _this3.currentHistoryState = args[0];
                        return pushState.apply(window.history, args);
                    };

                    window.history.replaceState = function () {
                        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                            args[_key2] = arguments[_key2];
                        }

                        _this3.currentHistoryState = args[0];
                        return replaceState.apply(window.history, args);
                    };

                    window.history.__tourHunterToggleStateTrackingPatched = true;
                }
            }, {
                key: "getBackInterceptConfig",
                value: function getBackInterceptConfig() {
                    var element = document.querySelector('.tour-hunter-toggle[data-enable-back-intercept="1"]');

                    if (!element) {
                        return null;
                    }

                    return {
                        element: element,
                        modalId: element.dataset.backInterceptModalId || '',
                        modalCssClass: element.dataset.backInterceptModalClass || ''
                    };
                }
            }, {
                key: "createBackInterceptState",
                value: function createBackInterceptState() {
                    return {
                        type: TOUR_HUNTER_BACK_INTERCEPT_STATE_TYPE,
                        timestamp: Date.now()
                    };
                }
            }, {
                key: "pushBackInterceptState",
                value: function pushBackInterceptState() {
                    if (!window.history) {
                        return;
                    }

                    window.history.pushState(this.createBackInterceptState(), document.title, window.location.href);
                }
            }, {
                key: "isModalState",
                value: function isModalState(state) {
                    return !!(state && (typeof state === "undefined" ? "undefined" : _typeof(state)) === 'object' && state.type === 'modal');
                }
            }, {
                key: "isBackInterceptState",
                value: function isBackInterceptState(state) {
                    return !!(state && (typeof state === "undefined" ? "undefined" : _typeof(state)) === 'object' && state.type === TOUR_HUNTER_BACK_INTERCEPT_STATE_TYPE);
                }
            }, {
                key: "handleNavBarBack",
                value: function handleNavBarBack(event) {
                    if (!this.backInterceptConfig || this.isBackNavigationConfirmed || this.isBackInterceptModalOpen || this.isTrackingTour()) {
                        return;
                    }

                    this.pendingBackNavigation = {
                        type: 'nav-bar',
                        backUrl: event.detail ? event.detail.backUrl || '' : '',
                        referrer: event.detail ? event.detail.referrer || '' : ''
                    };

                    event.preventDefault();
                    this.openBackInterceptModal();
                }
            }, {
                key: "handlePopState",
                value: function handlePopState(event) {
                    var previousState = this.currentHistoryState;
                    this.currentHistoryState = event.state;

                    if (!this.backInterceptConfig || this.isBackNavigationConfirmed || this.isTrackingTour()) {
                        return;
                    }

                    if (this.isModalState(previousState) || !this.isBackInterceptState(previousState)) {
                        return;
                    }

                    this.pendingBackNavigation = {
                        type: 'history-popstate'
                    };

                    this.pushBackInterceptState();
                    this.openBackInterceptModal();
                }
            }, {
                key: "openBackInterceptModal",
                value: function openBackInterceptModal() {
                    var _this4 = this;

                    if (!this.backInterceptConfig || !this.backInterceptConfig.modalId || !window.modal || typeof window.modal.open !== 'function' || this.isBackInterceptModalOpen) {
                        return;
                    }

                    this.isBackInterceptModalOpen = true;

                    window.modal.open({
                        header: null,
                        content: {
                            htmlDetachSelectorId: this.backInterceptConfig.modalId
                        },
                        parentCssClass: this.backInterceptConfig.modalCssClass,
                        footer: false,
                        type: 'bottom',
                        onBeforeClose: function onBeforeClose() {
                            _this4.isBackInterceptModalOpen = false;

                            if (!_this4.isBackNavigationConfirmed) {
                                _this4.pendingBackNavigation = null;
                            }
                        },
                        onBeforeRemove: function onBeforeRemove() {
                            if (!_this4.isBackNavigationConfirmed) {
                                return;
                            }

                            var pendingBackNavigation = _this4.pendingBackNavigation;
                            _this4.pendingBackNavigation = null;

                            window.setTimeout(function () {
                                _this4.continueBackNavigation(pendingBackNavigation);
                            }, 0);
                        }
                    });
                }
            }, {
                key: "isTrackingTour",
                value: function isTrackingTour() {
                    return !!(this.backInterceptConfig && this.backInterceptConfig.element && this.backInterceptConfig.element.dataset.isTrackingTour === '1');
                }
            }, {
                key: "setTrackingTourState",
                value: function setTrackingTourState(widgetElement, isTrackingTour) {
                    if (!widgetElement || !widgetElement.dataset) {
                        return;
                    }

                    widgetElement.dataset.isTrackingTour = isTrackingTour ? '1' : '0';
                }
            }, {
                key: "handleBackInterceptAdd",
                value: function handleBackInterceptAdd() {
                    var _this5 = this;

                    var button = this.backInterceptConfig ? this.backInterceptConfig.element.querySelector('.tour-hunter-toggle-btn') : null;
                    var tourId = this.getTourId(button);

                    if (!button || !tourId) {
                        return;
                    }

                    if (window.modal && typeof window.modal.close === 'function') {
                        window.modal.close('.modal2');
                    }

                    if (this.isAuthRequired(button)) {
                        this.sendToggleAnalytics(button, TOUR_HUNTER_STATUS_ADD, TOUR_HUNTER_BACK_INTERCEPT_PLACE, true);
                        this.storePendingTour(tourId);

                        window.setTimeout(function () {
                            _this5.openAuthModal(button);
                        }, 50);

                        return;
                    }

                    window.setTimeout(function () {
                        _this5.handleClick(button, TOUR_HUNTER_BACK_INTERCEPT_PLACE, true);
                    }, 50);
                }
            }, {
                key: "handleBackInterceptClose",
                value: function handleBackInterceptClose() {
                    this.isBackNavigationConfirmed = true;

                    if (window.modal && typeof window.modal.close === 'function') {
                        window.modal.close('.modal2');
                    }
                }
            }, {
                key: "continueBackNavigation",
                value: function continueBackNavigation(pendingBackNavigation) {
                    if (!pendingBackNavigation) {
                        this.isBackNavigationConfirmed = false;
                        return;
                    }

                    var referrer = pendingBackNavigation.referrer || document.referrer;
                    var returnsThroughHistory = pendingBackNavigation.type === 'history-popstate' || referrer && new URL(referrer, window.location.href).origin === window.location.origin;
                    if (returnsThroughHistory && this.isBackInterceptState(window.history.state) && window.history.length > 2) {
                        if (window.markHotelSearchBack) window.markHotelSearchBack(referrer);
                        window.history.go(-2);
                        return;
                    }

                    var backButton = document.getElementById('back-button');

                    if (backButton) {
                        backButton.click();
                        return;
                    }

                    var target = pendingBackNavigation.backUrl || app.backUrl;
                    if (window.markHotelSearchBack) {
                        window.markHotelSearchBack(target);
                    }
                    window.location.href = target;
                }
            }, {
                key: "handleClick",
                value: function handleClick(button) {
                    var place = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TOUR_HUNTER_TOGGLE_PLACE;
                    var useExplicitPlace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                    var tourId = this.getTourId(button);

                    if (!tourId) {
                        return;
                    }

                    if (button.classList.contains('remove-tracking-tour')) {
                        this.sendToggleAnalytics(button, TOUR_HUNTER_STATUS_REMOVE, place, useExplicitPlace);
                        this.removeTour(button);
                        return;
                    }

                    this.sendToggleAnalytics(button, TOUR_HUNTER_STATUS_ADD, place, useExplicitPlace);

                    if (this.isAuthRequired(button)) {
                        this.storePendingTour(tourId);

                        if (!button.classList.contains('show-auth-modal') || this.hasDesktopAuthModal()) {
                            this.openAuthModal(button);
                        }

                        return;
                    }

                    this.addTour(button, tourId);
                }
            }, {
                key: "isAuthRequired",
                value: function isAuthRequired(button) {
                    return !!window.authWidget || button.classList.contains('show-auth-modal');
                }
            }, {
                key: "hasDesktopAuthModal",
                value: function hasDesktopAuthModal() {
                    return !!document.getElementById('auth-modal');
                }
            }, {
                key: "getTourId",
                value: function getTourId(button) {
                    if (!button || !button.dataset) {
                        return '';
                    }

                    return button.dataset.tourId || '';
                }
            }, {
                key: "getTrackingId",
                value: function getTrackingId(button) {
                    if (!button || !button.dataset) {
                        return '';
                    }

                    return button.dataset.trackingId || '';
                }
            }, {
                key: "getRelatedButtons",
                value: function getRelatedButtons(button) {
                    var tourId = this.getTourId(button);

                    if (!tourId) {
                        return [];
                    }

                    return Array.from(document.querySelectorAll('.tour-hunter-toggle-btn[data-tour-id="' + tourId + '"]'));
                }
            }, {
                key: "getPageType",
                value: function getPageType(button) {
                    var widgetElement = button ? button.closest('.tour-hunter-toggle') : null;

                    if (!widgetElement || !widgetElement.dataset) {
                        return '';
                    }

                    return widgetElement.dataset.pageType || '';
                }
            }, {
                key: "getPlace",
                value: function getPlace(button) {
                    var fallbackPlace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TOUR_HUNTER_TOGGLE_PLACE;

                    if (!button || !button.dataset) {
                        return fallbackPlace;
                    }

                    return button.dataset.place || fallbackPlace;
                }
            }, {
                key: "sendToggleAnalytics",
                value: function sendToggleAnalytics(button, status, place) {
                    var useExplicitPlace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

                    if (!window.brxTracking || typeof window.brxTracking.sendAnalyticsEvent !== 'function') {
                        return;
                    }

                    var tourId = this.getTourId(button);
                    var trackingId = this.getTrackingId(button);
                    var eventProperties = {
                        Status: status,
                        Place: useExplicitPlace ? place : this.getPlace(button, place),
                        Page: this.getPageType(button)
                    };

                    if (trackingId) {
                        eventProperties.TrackingId = trackingId;
                    } else if (tourId) {
                        eventProperties.TourId = tourId;
                    }

                    window.brxTracking.sendAnalyticsEvent(TOUR_HUNTER_TOGGLE_EVENT_NAME, eventProperties);
                }
            }, {
                key: "sendAddSuccessAnalytics",
                value: function sendAddSuccessAnalytics(button) {
                    var trackingId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

                    if (!window.brxTracking || typeof window.brxTracking.sendAnalyticsEvent !== 'function') {
                        return;
                    }

                    var tourId = this.getTourId(button);
                    var eventProperties = {
                        Place: this.getPlace(button, TOUR_HUNTER_TOGGLE_PLACE),
                        Page: this.getPageType(button)
                    };

                    if (trackingId) {
                        eventProperties.TrackingId = trackingId;
                    } else if (tourId) {
                        eventProperties.TourId = tourId;
                    }

                    window.brxTracking.sendAnalyticsEvent(TOUR_HUNTER_ADD_SUCCESS_EVENT_NAME, eventProperties);
                }
            }, {
                key: "storePendingTour",
                value: function storePendingTour(tourId) {
                    if (!tourId) {
                        return;
                    }

                    sessionStorage.setItem(TOUR_HUNTER_PENDING_TOUR_ID_KEY, tourId);
                }
            }, {
                key: "openAuthModal",
                value: function openAuthModal(button) {
                    if (!window.authWidget) {
                        return;
                    }

                    var afterAuthUrl = button && button.dataset && button.dataset.afterAuthUrl ? button.dataset.afterAuthUrl : window.location.href;

                    if (window.authWidget.links) {
                        window.authWidget.links.afterLoginRedirectLink = afterAuthUrl;
                    }

                    var desktopAuthModal = document.getElementById('auth-modal');

                    if (desktopAuthModal && typeof Modal !== 'undefined') {
                        window.modals = { auth: new Modal({ el: desktopAuthModal }).show() };

                        var phoneInput = desktopAuthModal.querySelector('.auth-form__phone');

                        if (phoneInput) {
                            phoneInput.focus();
                        }

                        if (typeof window.authWidget.sendOpenEvent === 'function') {
                            window.authWidget.sendOpenEvent();
                        }

                        return;
                    }

                    if (!window.modal || typeof window.modal.open !== 'function') {
                        return;
                    }

                    window.modal.open({
                        header: {
                            title: window.authWidget.labels.title
                        },
                        content: {
                            htmlDetachSelectorId: 'authModal'
                        },
                        parentCssClass: 'bottom-scheat-auth',
                        footer: false,
                        type: 'bottom',
                        onBeforeClose: function onBeforeClose() {},
                        onAfterShow: function onAfterShow() {
                            window.authWidget.sendOpenEvent();
                        }
                    });
                }
            }, {
                key: "createPopup",
                value: function createPopup() {
                    if (this.popup) {
                        return this.popup;
                    }

                    var popup = document.createElement('div');
                    popup.className = 'tour-hunter-popup hide';

                    if (this.isDesktopPopup()) {
                        popup.classList.add('tour-hunter-popup--desktop');
                    }

                    popup.innerHTML = ['<div class="tour-hunter-popup-content">', '  <img src="" class="emoji hide" alt="">', '  <div>', '    <span class="great hide"></span>', '    <span class="done hide"></span>', '    <span class="tour-hunter-added hide"></span>', '    <span class="tour-hunter-removed hide"></span>', '  </div>', '</div>'].join('');

                    document.body.appendChild(popup);
                    this.popup = popup;

                    return popup;
                }
            }, {
                key: "isDesktopPopup",
                value: function isDesktopPopup() {
                    return !document.getElementById('mobileModal');
                }
            }, {
                key: "getPopupText",
                value: function getPopupText(key) {
                    return this.popupTexts && this.popupTexts[key] ? this.popupTexts[key] : '';
                }
            }, {
                key: "showPopup",
                value: function showPopup(isAdded) {
                    var _this6 = this;

                    var popup = this.createPopup();
                    var emoji = popup.querySelector('.emoji');
                    var great = popup.querySelector('.great');
                    var done = popup.querySelector('.done');
                    var added = popup.querySelector('.tour-hunter-added');
                    var removed = popup.querySelector('.tour-hunter-removed');

                    popup.querySelectorAll('.great, .done, .tour-hunter-added, .tour-hunter-removed, .emoji').forEach(function (el) {
                        el.classList.add('hide');
                    });

                    if (this.popupHideTimer) {
                        window.clearTimeout(this.popupHideTimer);
                        this.popupHideTimer = null;
                    }

                    if (this.popupFadeTimer) {
                        window.clearTimeout(this.popupFadeTimer);
                        this.popupFadeTimer = null;
                    }

                    if (isAdded) {
                        emoji.src = '/x-assets/img/emoji/white-heart-in-red-square.svg';
                        great.textContent = this.getPopupText('great');
                        added.textContent = this.getPopupText('added');
                        emoji.classList.remove('hide');
                        great.classList.remove('hide');
                        added.classList.remove('hide');
                    } else {
                        emoji.src = '/x-assets/img/emoji/emoji-ok.png';
                        done.textContent = this.getPopupText('done');
                        removed.textContent = this.getPopupText('removed');
                        emoji.classList.remove('hide');
                        done.classList.remove('hide');
                        removed.classList.remove('hide');
                    }

                    popup.classList.add('ease-show');
                    popup.classList.remove('hide');

                    this.popupHideTimer = window.setTimeout(function () {
                        popup.classList.remove('ease-show');

                        _this6.popupFadeTimer = window.setTimeout(function () {
                            popup.classList.add('hide');
                            _this6.popupFadeTimer = null;
                        }, 500);
                    }, 3000);
                }
            }, {
                key: "startPendingTourSync",
                value: function startPendingTourSync() {
                    var _this7 = this;

                    if (!sessionStorage.getItem(TOUR_HUNTER_PENDING_TOUR_ID_KEY)) {
                        return;
                    }

                    if (this.processPendingTour()) {
                        return;
                    }

                    this.pendingTourSyncTimer = window.setInterval(function () {
                        if (_this7.processPendingTour()) {
                            window.clearInterval(_this7.pendingTourSyncTimer);
                            _this7.pendingTourSyncTimer = null;
                        }
                    }, 200);
                }
            }, {
                key: "processPendingTour",
                value: function processPendingTour() {
                    var pendingTourId = sessionStorage.getItem(TOUR_HUNTER_PENDING_TOUR_ID_KEY);

                    if (!pendingTourId || window.authWidget || this.pendingTourInProgress) {
                        return false;
                    }

                    var button = document.querySelector('.tour-hunter-toggle-btn[data-tour-id="' + pendingTourId + '"]');

                    if (!button) {
                        return false;
                    }

                    this.addTour(button, pendingTourId);

                    return true;
                }
            }, {
                key: "addTour",
                value: function addTour(button, tourId) {
                    var _this8 = this;

                    if (!tourId) {
                        return;
                    }

                    this.pendingTourInProgress = sessionStorage.getItem(TOUR_HUNTER_PENDING_TOUR_ID_KEY) === tourId;

                    ajax.post('/new/tour-hunter/add', {
                        params: {
                            tourId: tourId
                        }
                    }, function (data) {
                        _this8.pendingTourInProgress = false;

                        if (!data || !data.success) {
                            return;
                        }

                        sessionStorage.removeItem(TOUR_HUNTER_PENDING_TOUR_ID_KEY);
                        _this8.markAsTracked(button, data.trackingId || '');
                        _this8.sendAddSuccessAnalytics(button, data.trackingId || '');
                        _this8.showPopup(true);
                    });
                }
            }, {
                key: "removeTour",
                value: function removeTour(button) {
                    var _this9 = this;

                    var trackingId = button.dataset.trackingId || '';

                    if (!trackingId) {
                        return;
                    }

                    ajax.post('/new/tour-hunter/remove', {
                        params: {
                            trackingId: trackingId
                        }
                    }, function (data) {
                        if (!data || !data.success) {
                            return;
                        }

                        _this9.markAsNotTracked(button);
                        _this9.showPopup(false);
                    });
                }
            }, {
                key: "markAsTracked",
                value: function markAsTracked(button, trackingId) {
                    var _this10 = this;

                    if (!button) {
                        return;
                    }

                    this.getRelatedButtons(button).forEach(function (relatedButton) {
                        relatedButton.classList.remove('add-tracking-tour', 'show-auth-modal');
                        relatedButton.classList.add('remove-tracking-tour');

                        if (trackingId) {
                            relatedButton.dataset.trackingId = trackingId;
                        }

                        var icon = relatedButton.querySelector('img');
                        if (icon) {
                            icon.src = '/x-assets/img/icons/icon-filled-heart.svg';
                            icon.alt = 'Unlike';
                        }

                        _this10.setTrackingTourState(relatedButton.closest('.tour-hunter-toggle'), true);
                    });
                }
            }, {
                key: "markAsNotTracked",
                value: function markAsNotTracked(button) {
                    var _this11 = this;

                    if (!button) {
                        return;
                    }

                    this.getRelatedButtons(button).forEach(function (relatedButton) {
                        relatedButton.classList.remove('remove-tracking-tour');
                        relatedButton.classList.add('add-tracking-tour');
                        delete relatedButton.dataset.trackingId;

                        var icon = relatedButton.querySelector('img');
                        if (icon) {
                            icon.src = '/x-assets/img/icons/icon-unfilled-heart-blue.svg';
                            icon.alt = 'Like';
                        }

                        _this11.setTrackingTourState(relatedButton.closest('.tour-hunter-toggle'), false);
                    });
                }
            }]);

            return TourHunterToggleWidget;
        }();

        document.addEventListener('DOMContentLoaded', function () {
            window.tourHunterToggleWidget = new TourHunterToggleWidget();
        });
    }, {}] }, {}, [1]);